import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { mainTreeActions } from "@/store/actions";

// Use this hook to store the initial data from SSR to redux.
export const useStoreSSRInitialDataBook = (bookOrBooks) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (bookOrBooks) {
      dispatch(mainTreeActions.addBooks(bookOrBooks));
    }
  }, []);
};